export default {"src":"/_next/static/media/OTIS.85b8cb8f.svg","height":18,"width":18};